import { Component, OnInit, OnDestroy } from '@angular/core';
import { ThemeMode } from '../../../../providers/dark-mode/dark-mode';

@Component({
  selector: 'page-event-organizer',
  templateUrl: 'event-organizer.html'
})
export class EventOrganizerPage implements OnInit, OnDestroy {
  themeMode
  constructor() { }

  ngOnInit(): void {
    this.themeMode = JSON.parse(localStorage.getItem('darkMode') || `"${ThemeMode.LightMode}"`) as ThemeMode;
  }

  ngOnDestroy(): void {

  }

  todo(){
    
  }

}



// WEBPACK FOOTER //
// /src/pages/event/details/event-organizer/event-organizer.ts